// 字典管理
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid stripe border="default" show-overflow height="100%" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button v-if="sys_dict_add" status="primary" class="button-sty" icon="el-icon-plus" @click="openEditDialog">新增
                  </vxe-button>
                  <vxe-button status="primary" class="button-sty" icon="el-icon-refresh-left" @click="handleRefreshCache">缓存
                  </vxe-button>
                </div>
                <div class="fr">
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="8vw" style="display:flex;flex-direction: column;" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <vxe-form-item title="类型:" field="code">
                  <template v-slot>
                    <el-input v-model="formData.dictType" size="small" style="width: 9vw !important; ;" clearable />
                  </template>
                </vxe-form-item>
                <vxe-form-item title="字典类型:" field="code">
                  <template v-slot>
                    <el-select v-model="formData.systemFlag" clearable style="width: 9vw !important; ;">
                      <el-option v-for="item in dictTypes" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </vxe-form-item>

              </vxe-form>
            </template>

            <template #option="{row}">
              <div>
                <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id)">
                <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                            popper-class="tooltip-skin">
                  <i class="el-icon-edit" />
                </el-tooltip>
                </a>
                <a href="javascript:void(0);" v-if="sys_dict_del" class="a-link" @click="doDelete(row)">
                <el-tooltip enterable={false} effect="dark" content="删除" placement="top"
                            popper-class="tooltip-skin">
                  <i class="el-icon-delete" />
                </el-tooltip>
                </a>
              </div>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import { fetchTree } from "@/api/admin/type_tree"
import api from "@/api/projectApi";
import request from "@/router/axios";
import {
  delObj,
  refreshCache
} from '@/api/admin/dict'
import {mapGetters} from "vuex";
import {indexPageMixins} from "@/mixins/tabChang";
export default {
  name:'dict',
  mixins: [indexPageMixins],
  components: { editView, pager },
  data() {
    return {
      sys_dict_edit: false,
      sys_dict_add: false,
      sys_dict_del: false,
      dictTypes:[],
      total: 0,
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},

      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
      },

      formData: {
        createTimeBegin: null,
        createTimeEnd: null,
      },
      productOptions0: [],
      productOptions1: [],
      pageSizes: [10, 20, 100],
      columns: [
        { type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
        { title: '类型', field: 'dictType', width: 120, },
        { title: '编码', field: 'description', width: 120, },
        { title: '字典类型', field: 'systemFlag', width: 120, slots: {
            default: ({ row }) => {
              if (row.systemFlag == 0) {
                return [
                  <div>
                  <span>业务</span>
                  </div>
              ];
              } else if (row.systemFlag == 1) {
                return [
                  <div>
                  <span>系统</span>
                  </div>
              ];
              }
            }
          }},
        { title: '备注信息', field: 'remarks', width: 250},
        { title: '创建人', field: 'createBy', width: 100, },
        { field: 'createTime', title: '创建时间', width: 150 },
        { width: 100, fixed: 'right', title: '', sortable: false, slots: {default: 'option'}
        }
      ]
    }
  },
  mounted() {
    this.getDictTypes()
    this.initSearchDate()
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.sys_dict_edit = this.permissions['sys_dict_edit']
    this.sys_dict_add = this.permissions['sys_dict_add']
    this.sys_dict_del = this.permissions['sys_dict_del']
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  methods: {
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    getDictTypes(){
      this.$http({
        url: "/admin/dict/type/dict_type",
        method: 'get',
      }).then(res => {
        this.dictTypes = res.data.data;
      })
    },

    doDelete(row){
      this.$confirm('是否确认删除数据类型为"' + row.dictType + '"的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delObj(row).then(() => this.getTableData())
      }).then(() => {
        this.getList(this.page)
        this.$message.success('删除成功')
      }).catch(function () {
      })
    },
    handleRefreshCache: function () {
      refreshCache().then(() => {
        this.$message.success('同步成功')
      }).catch(function () {
      })
    },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.dict.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },


    // 搜索
    searchEvent() {
      this.setRequestParam()

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
      }
      this.setRequestParam()

      this.requestParam.searchCount = false
      this.requestParam.current = 1

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    setRequestParam() {
      this.requestParam.dictType = this.formData.dictType
      this.requestParam.systemFlag = this.formData.systemFlag
    },
    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
// ::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
//   display: inline-block;
//   width: 20%;
// }
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}
</style>
